import { ErrorConfigurations } from './ErrorConfigurations';

export default class ValidationFunctions {
  static checkIsMobileValid(mobile) {
    if (mobile.length == 0) {
      return ErrorConfigurations.message['mobileRequired'];
    } else if (
      !ErrorConfigurations.pattern['internationalPhone'].test(mobile)
    ) {
      return ErrorConfigurations.message['invalidMobile'];
    } else if (mobile.length != 14) {
      return ErrorConfigurations.message['invalidMobile'];
    } else {
      return null;
    }
  }

  static checkIsEmailValid(email) {
    if (email == '') {
      return ErrorConfigurations.message['emailRequired'];
    } else if (!ErrorConfigurations.pattern['email'].test(email)) {
      return ErrorConfigurations.message['invalidEmail'];
    }
  }

  static checkIsPincodeValid(pincode) {
    if (pincode == '') {
      return ErrorConfigurations.message['pincodeRequired'];
    } else if (
      !ErrorConfigurations.pattern['onlyNumberWithZeroAtStart'].test(pincode) ||
      pincode.length < ErrorConfigurations.maxLength['pincode']
    ) {
      return ErrorConfigurations.message['invalidPincode'];
    }
  }

  static checkSerialNumber(serialNumber) {
    if (serialNumber == '') {
      return 'Required';
    } else if (
      !ErrorConfigurations.pattern['alphaNumeric'].test(serialNumber) ||
      serialNumber.length != 16
    ) {
      return 'Must Be Only 16 Alphanumberic Characters';
    }
  }

  static checkIsNameValid(name, type) {
    if (name == '') {
      return ErrorConfigurations.message[type.toLowerCase() + 'Required'];
    }
  }

  static checkIsPasswordValid(password) {
    if (password.length < 8) {
      return ErrorConfigurations.message['invalidPassword'];
    } else if (!ErrorConfigurations.pattern['upperCase'].test(password)) {
      return ErrorConfigurations.message['atLeastOneUppercase'];
    } else if (!ErrorConfigurations.pattern['lowerCase'].test(password)) {
      return ErrorConfigurations.message['atLeastOneLowercase'];
    } else if (!ErrorConfigurations.pattern['number'].test(password)) {
      return ErrorConfigurations.message['atLeastOneNumber'];
    } else if (
      !ErrorConfigurations.pattern['specialCharacter'].test(password)
    ) {
      return ErrorConfigurations.message['atLeastOneSpecial'];
    }
  }

  static checkPasswordRequired(password) {
    if (password == '') {
      return ErrorConfigurations.message['passwordRequired'];
    }
  }

  static check2FACodeValid(code) {
    if (code == '') {
      return ErrorConfigurations.message['twoFaCodeRequired'];
    } else if (
      !ErrorConfigurations.pattern['onlyNumberWithZeroAtStart'].test(code)
    ) {
      return ErrorConfigurations.message['twoFaCodeNumber'];
    }
  }
  static formatPhoneNumber(phoneNumber, country) {
    switch (country) {
      case 'IN': {
        return (
          phoneNumber
            ?.replace(/\D/g, '')
            .replace(/^(\d{5})(\d{5})$/, '$1-$2') || ''
        );
      }
      default: {
        return phoneNumber
          ?.replace(/\D+/g, '')
          .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      }
    }
  }
}
